import { FetchI18nResources } from './FetchI18nResources.mjs';

const fetchI18nResources = (requireContext) => {
  return new FetchI18nResources().exec(requireContext);
};

export { fetchI18nResources };
//# sourceMappingURL=index.mjs.map
